<template>
    <modal
        name="event-normal-filter-modal"
        class="event-modal"
        :width="'100%'"
        :height="'auto'"
        transition="modal-right"
        v-model="show"
        :pivotY="0.5"
        @before-open="handlerBeforeOpen"
        @before-close="handlerBeforeClose"
        @closed="handlerClosed"
    >
        <div class="container-full-modal" v-if="showModal">
            <div class="wrap-start-header pl16 pr16">
                <button class="btn-header back" @click="BackEvt()"></button>
                <div class="title-header">
                    {{ $t('filter') }}
                </div>
                <button class="g8014500" @click="resetFilter()">{{ $t('reset') }}</button>
            </div>
            <div class="content-full-modal">
                <div class="wrap-filter">
                    <div class="title-filter">{{ $t('event_status') }}</div>
                    <el-checkbox-group :class="'usest'" v-model="useSelect">
                        <el-checkbox
                            class="checkbox-common"
                            :label="'1'"
                        >{{ $t('intended') }}</el-checkbox>
                        <el-checkbox
                            class="checkbox-common"
                            :label="'2'"
                        >{{ $t('progress') }}</el-checkbox>
                        <el-checkbox
                            class="checkbox-common"
                            :label="'3'"
                        >{{ $t('terminated') }}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="wrap-filter">
                    <div class="title-filter">{{ $t('nticekt_sell_status') }}</div>
                    <el-checkbox-group :class="'sellst'" v-model="dealSelect">
                        <el-checkbox class="checkbox-common" :value="'1'" :label="'1'">
                            {{
                            $t('stay_buy')
                            }}
                        </el-checkbox>
                        <el-checkbox class="checkbox-common" :value="'2'" :label="'2'">
                            {{
                            $t('selling')
                            }}
                        </el-checkbox>
                        <el-checkbox class="checkbox-common" :value="'3'" :label="'3'">
                            {{
                            $t('sell_end')
                            }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
                <button
                    class="btn-common"
                    type="button"
                    :disabled="!btnStatus()"
                    @click="search()"
                >{{ $t('btn_settings_completion') }}</button>
            </div>
        </div>
    </modal>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import eventUtil from "@/components/event/eventUtil";

const { filterConfig } = eventUtil;
export default {
    name: "EventNormalFilterModal",
    mixins: [],
    components: {
        PageHeader,
    },
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            show: false,
            showModal: true,
            filterData: {},
            useSelect: [],
            dealSelect: [],
            paginationData: { default: { page: 1, size: 10, total: 0 } },
            filterStartPrice: "",
            filterEndPrice: "",
            errorMsg: "",
            isBtnAvailable: false,
            headerTitle: "",
        };
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {
       
        handlerBeforeOpen(event) {
            if (
                !util.isEmpty(event.params) &&
                !util.isEmpty(event.params.filterData)
            ) {
                this.filterData = event.params.filterData;
            }


            this.useSelect = this.filterData.usest;
            this.dealSelect = this.filterData.sellst;
        },
        handlerBeforeClose() {
            this.resetFilter();
        },
        handlerClosed() {},
        resetFilter() {
            this.useSelect = [];
            this.dealSelect = [];
        },
        search() {
            let data = {};
            data.usest = this.useSelect;
            data.sellst = this.dealSelect;
            EventBus.$emit("setEventFilterModal", data);
            this.modalClose();
        },
        modalClose() {
            this.$modal.hide("event-normal-filter-modal");
        },
    
        setDealStatusFilter(value) {
            if (!this.dealSelect.includes(value)) {
                this.dealSelect.push(value);
            } else {
                this.dealSelect = this.dealSelect.filter((el) => el !== value);
            }
        },

        btnStatus() {
            if (
                !util.isEmpty(this.filterStartPrice) &&
                util.isEmpty(this.filterEndPrice)
            ) {
                return false;
            }
            if (
                !util.isEmpty(this.filterEndPrice) &&
                util.isEmpty(this.filterStartPrice)
            ) {
                return false;
            }
            if (
                !util.isEmpty(this.filterStartPrice) ||
                !util.isEmpty(this.filterEndPrice)
            ) {
                return (
                    this.filterStartPrice <= this.filterEndPrice &&
                    util.isEmpty(this.errorMsg) &&
                    this.isBtnAvailable
                );
            } else {
                return true;
            }
        },
        checkMaxMin(data) {
            switch (data) {
                case "minPrice":
                    if (util.isEmpty(this.filterEndPrice)) {
                        this.errorMsg = "empty_max";
                        this.isBtnAvailable = false;
                        break;
                    }
                    if (
                        Number(this.filterStartPrice) >
                        Number(this.filterEndPrice)
                    ) {
                        if (this.filterEndPrice !== "") {
                            this.errorMsg = "min_warn";
                            this.isBtnAvailable = false;
                        } else {
                            this.errorMsg = "";
                            this.isBtnAvailable = true;
                        }
                    }
                    break;
                case "maxPrice":
                    if (util.isEmpty(this.filterStartPrice)) {
                        this.errorMsg = "empty_min";
                        this.isBtnAvailable = false;
                        break;
                    }
                    if (
                        Number(this.filterStartPrice) >
                        Number(this.filterEndPrice)
                    ) {
                        if (this.filterEndPrice !== "") {
                            this.errorMsg = "max_warn";
                            this.isBtnAvailable = false;
                        }
                    } else {
                        this.errorMsg = "";
                        this.isBtnAvailable = true;
                    }
                    break;
            }
        },
        BackEvt() {
            this.$modal.hide("event-normal-filter-modal");
        },
    },
    watch: {},
};
</script>

<style scoped>
</style>
